import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { MouseEvent } from 'react';
import { defineMessage, useIntl } from 'react-intl';

const closeMessage = defineMessage({
  id: 'notifications.toast.close',
  defaultMessage: 'Cerrar',
});

export type RibbonToastCloseButtonProps = {
  onClose: () => void;
};

/**
 * Dismiss control for a ribbon toast, aligned with the feed archive button.
 */
export function RibbonToastCloseButton({ onClose }: RibbonToastCloseButtonProps) {
  const $t = useIntl().formatMessage;

  function handleClick(event: MouseEvent) {
    event.stopPropagation();
    onClose();
  }

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      title={$t(closeMessage)}
      sx={{
        flexShrink: 0,
        p: 0.5,
        color: 'text.disabled',
        '&:hover': { color: 'text.secondary' },
        '& .MuiSvgIcon-root': { fontSize: 16 },
      }}
    >
      <CloseIcon />
    </IconButton>
  );
}
